// extracted by mini-css-extract-plugin
module.exports = {"ListHolder":"TransactionList_ListHolder__1fv1g","TransactionPart":"TransactionList_TransactionPart__1kFiL"};